import type { Locale } from "@/i18n";

export const BRAND = {
  name: "Zsolt MOLNAR",
  company: "GARLIC TECH",
} as const;

const CALENDLY_BASE = "https://calendly.com/garlictech/30min";

type BookingOffer = "build" | "ai-audit";
type BookingPlacement = "hero" | "pain-points" | "contact";

/** Tags each booking link so Calendly reports which offer and which part of the page won the click. */
export const bookingUrl = (offer: BookingOffer, placement: BookingPlacement) =>
  `${CALENDLY_BASE}?utm_source=garlictech.com&utm_content=${offer}&utm_term=${placement}`;

interface SiteCopy {
  hero: {
    kicker: string;
    estLine: string;
    studioLine: string;
    headline: string;
    headlineAccent: string;
    subheadline: string;
    bridgeLine: string;
    processLine: string;
    trustMarkers: readonly string[];
    ctaLabel: string;
    secondaryCtaLabel: string;
  };
  contact: {
    email: string;
  };
}

const en: SiteCopy = {
  hero: {
    kicker: "Garlic Tech · AI-native software studio",
    estLine: "Est 2014 · Budapest",
    studioLine:
      "Garlic Tech is an AI-native software studio. We build with AI, and we build AI.",
    headline: "Software delivery is measured in months. ",
    headlineAccent: "We measure it in weeks.",
    subheadline:
      "We have been building software since 2014 for banks, for small and mid-sized companies, and for startups in Hungary and abroad. It takes weeks because the routine work runs on AI-supported workflows, while the engineering decisions stay with a human.",
    bridgeLine:
      "If you are not getting anywhere with your current developer, the task may not be the problem.",
    processLine: "scope()  →  build()  →  handoff()",
    trustMarkers: ["20+ years", "CERN", "ESA", "Manifest OS"],
    ctaLabel: "Let's talk about your build →",
    secondaryCtaLabel: "Not sure where AI fits yet? Ask for an AI audit →",
  },
  contact: {
    email: "contact@garlictech.com",
  },
};

const hu: SiteCopy = {
  hero: {
    kicker: "Garlic Tech · AI-alapú fejlesztő stúdió",
    estLine: "2014 óta · Budapest",
    studioLine:
      "A Garlic Tech egy AI-alapú fejlesztő stúdió. AI-val fejlesztünk, és AI-t fejlesztünk.",
    headline: "A szoftverfejlesztés hónapokban mérhető. ",
    headlineAccent: "Nálunk hetekben.",
    subheadline:
      "2014 óta fejlesztünk szoftvert bankoknak, KKV-knak, valamint magyar és nemzetközi startupoknak. A rutin feladatokat nálunk AI-alapú munkafolyamatok viszik, de a szakmai döntéseket továbbra is ember hozza. Ezért készül el hetek alatt.",
    bridgeLine:
      "Ha az eddigi fejlesztőddel nem jutottál előre, nem biztos, hogy a feladattal van a baj.",
    processLine: "scope()  →  build()  →  handoff()",
    trustMarkers: ["20+ év", "CERN", "OTP Bank", "Manifest OS"],
    ctaLabel: "Beszéljünk a fejlesztésedről →",
    secondaryCtaLabel: "Még csak keresed, hol segít az AI? Kérj AI-auditot →",
  },
  contact: {
    email: "contact@garlictech.com",
  },
};

export const SITE_CONFIG: Record<Locale, SiteCopy> = {
  en,
  hu,
};
